import React, { useState } from 'react';
import BuyerForm from './BuyerForm';
import ProductSelect from './ProductSelect';
import PaymentForm from './PaymentForm';
import DeliveryForm from './DeliveryForm';
import Button from '../common/Button';
import { generatePDFContract } from '../../utils/pdfGenerator';

const ContractForm = ({ data, onChange }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isGenerating, setIsGenerating] = useState(false);
  const totalSteps = 4;

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validações básicas
    if (!data.buyer?.name && !data.buyer?.companyName) {
      alert('Por favor, preencha os dados do comprador.');
      return;
    }
    
    if (!data.products || data.products.length === 0) {
      alert('Por favor, adicione pelo menos um produto.');
      return;
    }
    
    if (!data.payment?.method) {
      alert('Por favor, selecione uma forma de pagamento.');
      return;
    }

    setIsGenerating(true);
    
    try {
      await generatePDFContract(data);
      alert('Contrato gerado e baixado com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      alert('Erro ao gerar o contrato. Tente novamente.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center mb-8">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div key={i} className="flex items-center">
            <button
              type="button"
              onClick={() => setCurrentStep(i + 1)}
              className={`w-8 h-8 rounded-full flex items-center justify-center font-medium text-sm ${
                i + 1 <= currentStep 
                  ? 'bg-primary text-white' 
                  : 'bg-gray-200 text-gray-500'
              }`}
            >
              {i + 1}
            </button>
            {i < totalSteps - 1 && (
              <div 
                className={`h-1 w-12 ${
                  i + 1 < currentStep ? 'bg-primary' : 'bg-gray-200'
                }`}
              />
            )}
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {currentStep === 1 && (
          <BuyerForm 
            data={data.buyer} 
            onChange={(buyerData) => onChange({ buyer: buyerData })} 
          />
        )}

        {currentStep === 2 && (
          <ProductSelect 
            selectedProducts={data.products}
            onChange={(products) => onChange({ products })}
          />
        )}

        {currentStep === 3 && (
          <PaymentForm 
            data={data.payment}
            products={data.products}
            onChange={(payment) => onChange({ payment })}
          />
        )}

        {currentStep === 4 && (
          <DeliveryForm 
            data={data.delivery}
            products={data.products}
            onChange={(delivery) => onChange({ delivery })}
          />
        )}

        <div className="flex justify-between pt-4">
          {currentStep > 1 ? (
            <Button 
              type="button" 
              onClick={prevStep}
              variant="outline"
              disabled={isGenerating}
            >
              Voltar
            </Button>
          ) : (
            <div></div>
          )}
          
          {currentStep < totalSteps ? (
            <Button 
              type="button" 
              onClick={nextStep}
              disabled={isGenerating}
            >
              Próximo
            </Button>
          ) : (
            <Button 
              type="submit" 
              disabled={isGenerating}
            >
              {isGenerating ? 'Gerando...' : 'Gerar Contrato'}
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ContractForm;